// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anim-width[data-v-337438d0]{transition:width;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.3s}", ""]);
// Exports
module.exports = exports;
